import { __assign, __rest } from "tslib";
import React from 'react';
import { useQrious } from './use-qrious';
export var QRious = function (_a) {
    var background = _a.background, backgroundAlpha = _a.backgroundAlpha, foreground = _a.foreground, foregroundAlpha = _a.foregroundAlpha, level = _a.level, mime = _a.mime, padding = _a.padding, value = _a.value, size = _a.size, props = __rest(_a, ["background", "backgroundAlpha", "foreground", "foregroundAlpha", "level", "mime", "padding", "value", "size"]);
    var dataUrl = useQrious({
        background: background,
        backgroundAlpha: backgroundAlpha,
        foreground: foreground,
        foregroundAlpha: foregroundAlpha,
        level: level,
        mime: mime,
        padding: padding,
        size: size,
        value: value,
    })[0];
    return React.createElement('img', __assign(__assign({}, props), { src: dataUrl }));
};
//# sourceMappingURL=QRious.js.map